var map = {
	"./2012-05-03-resist-the-future.md": 4934,
	"./2012-06-07-mac-fonts.md": 7353,
	"./2014-06-23-delta-rae.md": 4858,
	"./2014-07-08-spruce-street-harbor.md": 4090,
	"./2014-08-29-brooklyn-bridge.md": 7937,
	"./2014-09-19-queue-for-the-iphone-6.md": 8833,
	"./2014-09-20-long-exposure-under-the-ben-franklin.md": 3082,
	"./2014-09-30-a-quick-retreat-from-the-noise.md": 8949,
	"./2014-12-22-a-thrill-of-hope.md": 5967,
	"./2015-01-06-first-snowfall-of-the-winter.md": 1885,
	"./2015-05-10-discover-the-railyard.md": 7291,
	"./2015-12-15-mile.md": 5221,
	"./2016-09-21-sunset.md": 9936,
	"./2017-08-06-when-is-golden-hour.md": 591,
	"./2019-05-31-secure-cloud-storage.md": 7575,
	"./2019-08-10-when-is-golden-hour-updates.md": 7086,
	"./2020-11-02-x100v.md": 3480,
	"./2025-09-10-septa-live.md": 980,
	"./2026-04-20-be-a-builder.md": 7456,
	"./2026-08-01-investing-101-for-swe.md": 3346,
	"pages/posts/2012-05-03-resist-the-future.md": 4934,
	"pages/posts/2012-06-07-mac-fonts.md": 7353,
	"pages/posts/2014-06-23-delta-rae.md": 4858,
	"pages/posts/2014-07-08-spruce-street-harbor.md": 4090,
	"pages/posts/2014-08-29-brooklyn-bridge.md": 7937,
	"pages/posts/2014-09-19-queue-for-the-iphone-6.md": 8833,
	"pages/posts/2014-09-20-long-exposure-under-the-ben-franklin.md": 3082,
	"pages/posts/2014-09-30-a-quick-retreat-from-the-noise.md": 8949,
	"pages/posts/2014-12-22-a-thrill-of-hope.md": 5967,
	"pages/posts/2015-01-06-first-snowfall-of-the-winter.md": 1885,
	"pages/posts/2015-05-10-discover-the-railyard.md": 7291,
	"pages/posts/2015-12-15-mile.md": 5221,
	"pages/posts/2016-09-21-sunset.md": 9936,
	"pages/posts/2017-08-06-when-is-golden-hour.md": 591,
	"pages/posts/2019-05-31-secure-cloud-storage.md": 7575,
	"pages/posts/2019-08-10-when-is-golden-hour-updates.md": 7086,
	"pages/posts/2020-11-02-x100v.md": 3480,
	"pages/posts/2025-09-10-septa-live.md": 980,
	"pages/posts/2026-04-20-be-a-builder.md": 7456,
	"pages/posts/2026-08-01-investing-101-for-swe.md": 3346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2056;